"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_DOCUMENT_VERSION_HISTORY_RESPONSE_EXAMPLE = exports.CLINICAL_DOCUMENT_WORKFLOW_RESPONSE_EXAMPLE = void 0;
const clinical_common_response_1 = require("./clinical-common.response");
exports.CLINICAL_DOCUMENT_WORKFLOW_RESPONSE_EXAMPLE = {
    document: clinical_common_response_1.CLINICAL_DOCUMENT_RESPONSE_EXAMPLE,
    timeline: [clinical_common_response_1.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE],
    notificationSent: false,
};
exports.CLINICAL_DOCUMENT_VERSION_HISTORY_RESPONSE_EXAMPLE = [
    clinical_common_response_1.CLINICAL_DOCUMENT_VERSION_RESPONSE_EXAMPLE,
];
//# sourceMappingURL=clinical-document.response.js.map